import React from 'react';
import {connectHits, connectStateResults} from 'react-instantsearch-dom';
import Hit from "./Hit";

const Hits = ({searchState, searchResults, hits, searching, indexId}) => {
    return (
        <article className="formations">
            {searchState && searchState.query && (
                <h2>Résultat pour votre recherche "{searchState.query}"</h2>
            )}
            {(searchResults && searchResults.nbHits !== 0) ? (
                hits.map(hit => (
                    <Hit key={hit.objectID} hit={hit} />
                ))
            ) : (
                <div>Aucun résultat</div>
            )}
        </article>
    )
};

export default connectHits(connectStateResults(Hits));
